import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { Asset, Entry } from 'contentful';

import { ContentService } from '@src/app/shared/services/content.service';

export interface BlogEntry {
  id: string;
  title: string;
  excerpt?: string;
  image?: string;
  tags?: string[];
  category?: string;
}

@Component({
  selector: 'app-entry-card',
  templateUrl: './entry-card.component.html',
  styleUrls: ['./entry-card.component.scss']
})
export class EntryCardComponent implements OnInit, OnDestroy {
  @Input() entry: Entry<any> | null;
  @Input() entryClass: string;
  @Output() open = new EventEmitter<Entry<any>>();

	entrySub: Subscription;
	excerptLimit: number = 200;
  placeholderImg: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    protected contentService: ContentService
  ) { }

  onOpen(): void {
    if (this.document.body.dataset?.filterMenuOpen === 'true') {
      return;
    }

    if (this.entry) {
      this.open.emit(this.entry);
    }
  }

	// Lifecycle Hooks

	async ngOnInit(): Promise<void> {
    this.placeholderImg = (await this.contentService.placeholderImg).fields.file.url;
	}
	
	ngOnDestroy(): void {
	}
}
